import { Routes, Route } from 'react-router-dom'
import PartsOnWorkOrders from './views/PartsOnWorkOrders'
import IncomingPartsTransfers from './views/IncomingPartsTransfers'
import OutgoingPartsTransfers from './views/OutgoingPartsTransfers'
import InventoryAdjustments from './views/InventoryAdjustments'

export default function Reports(): JSX.Element {
	return (
		<Routes>
			<Route path="parts-on-work-orders" element={<PartsOnWorkOrders />} />
			<Route path="incoming-parts-transfers" element={<IncomingPartsTransfers />} />
			<Route path="outgoing-parts-transfers" element={<OutgoingPartsTransfers />} />
			<Route path="inventory-adjustments" element={<InventoryAdjustments />} />
		</Routes>
	)
}
